import {
  TextField,
  Grid,
  Toolbar,
  Typography,
  Button
} from "@material-ui/core";
import React from "react";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core/styles";
import CalendarTodayOutlinedIcon from "@material-ui/icons/CalendarTodayOutlined";
import moment from "moment";
import PropTypes from "prop-types";
// import DatePicker from 'react-datetime';
// Material-ui datetime picker
import MomentUtils from "@date-io/moment";
import { MuiPickersUtilsProvider, DatePicker } from "@material-ui/pickers";
import "moment/locale/vi";
import "moment/locale/en-ca";
// Style
import { styles } from "./styles";
class PickerDate extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      time: this.props.time || moment(),
      locale: "vi"
    };
    // this.handleChange = this.handleChange.bind(this)
  }
  async componentDidMount() {}
  componentWillReceiveProps(nextProps) {
    if (nextProps.time) {
      this.setState({ time: nextProps.time.valueOf() });
    }
  }
  // handleChange(value, nameInput) {
  //   const _this = this;
  //   this.setState({ time: value }, function() {
  //     _this.props.handleChange(value, nameInput);
  //   })
  // }
  handleChangeTimeFromParent(value) {
    // gọi từ component cha
    this.setState({ time: value });
  }
  renderMonth = (props, month, year, selectedDate) => {
    return <td {...props}>{month + 1}</td>;
  };
  render() {
    const { classes, i18n, t, handleChange, nameInput = "" } = this.props;
    const { time } = this.state;
    moment.locale(i18n.language === "vn" ? "vi" : "en");
    return (
      <React.Fragment>
        <MuiPickersUtilsProvider
          libInstance={moment}
          utils={MomentUtils}
          locale={i18n.language === "vn" ? "vi" : "en"}
        >
          <DatePicker
            TextFieldComponent={props => (
              <Button
                classes={{
                  root: classes.btnRoot
                }}
                {...props}
              >
                <CalendarTodayOutlinedIcon className={classes.calendarIcon} />
                {props.value}
              </Button>
            )}
            openTo="month"
            // views={["year", "month"]}
            format="DD/MM/YYYY"
            renderMonth={this.renderMonth}
            value={time}
            onChange={value => handleChange(value, nameInput)}
            cancelLabel={t("date_picker_cancel")}
            okLabel={t("date_picker_ok")}
          />
        </MuiPickersUtilsProvider>
      </React.Fragment>
    );
  }
}

PickerDate.propTypes = {
  classes: PropTypes.object.isRequired
};
const mapState = state => ({});

const mapDispatch = dispatch => ({});

export default connect(
  mapState,
  mapDispatch
)(translate("translations")(withStyles(styles)(PickerDate)));
